import React from "react";
import { Dropdown, DropdownProps } from "antd";
import { FaChevronDown } from "react-icons/fa";
import get from "lodash/get";
import classNames from "classnames";

// components
import InfoTooltip from "@/components/InfoTooltip";

// helpers
import { CURRENCY_TOOLTIP_INFO } from "@/helpers/currencyUtils";
import currencies from "@/api/query/currencies";
import useCurrency from "@/hooks/useCurrency";
import useUserProfile from "@/hooks/useUserProfile";
import { useLockoutModalContext } from "@/contexts/LockoutModalContext";
import customDataLayerPush from "@/helpers/customDataLayerPush";

// interfaces
import { ICurrency } from "@/types/api/Currency";

// assets
import EarthGlobeIcon from "@/components/icons/EarthGlobeIcon";
import styles from "@/assets/styles/components/header-dropdown.module.scss";


const HeaderCurrencySelector = ({ isMobile }: { isMobile?: boolean }) => {
  const [currentCurrency, onChangeCurrency] = useCurrency();
  const { isAuthorized } = useUserProfile();
  const { setState } = useLockoutModalContext();

  const currenciesListUtils = currencies.useCurrenciesList();

  const isShowLofo = process.env.NEXT_PUBLIC_APP_WL_CODE === "LOCL" && !isAuthorized;

  const currenciesOptions = (currenciesListUtils.data || []).map(item => ({
    label: item.code,
    value: item.code,
    currencyObj: item
  }));

  const selectedCurrency = currenciesOptions.find(item => item.value === currentCurrency);
  const containerClassName = classNames(
    styles["locl-header-dropdown"],
    styles["locl-header-dropdown__currency"],
    { [styles["locl-header-dropdown__mobile"]]: isMobile }
  );

  // methods
  const handleChangeCurrency = (e: { currencyObj: ICurrency }) => {
    onChangeCurrency(e.currencyObj);
  };
  
  const handleShowLofo = () => {
    if (isShowLofo) {
      setState({ open: true });
      customDataLayerPush("lo_fo_modal_popup_shown", null, { lofo_type: "soft lofo" });
    }
  };

  // renders
  const menuItems = currenciesOptions.map(item => {
    return ({
      label: (
        <div
          onClick={() => handleChangeCurrency(item)}
          key={item.label}
          data-testid="locl-header-dropdown-currency-item"
        >
          {item.label}
        </div>
      )
    });
  });

  return (
    <div className={containerClassName} data-testid="locl-header-dropdown-currency">
      <Dropdown
        getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
        overlayClassName={styles["locl-header-dropdown__dropdown"]}
        menu={{ items: menuItems } as DropdownProps["menu"]}
        trigger={["click"]}
        placement={isMobile ? "bottomRight" : "bottom" }
        disabled={isShowLofo}
      >
        <div className={styles["locl-header-dropdown__button"]} onClick={() => handleShowLofo()} data-testid="locl-header-dropdown-currency-button">
          <div className={styles["locl-header-dropdown__button-icon"]}><EarthGlobeIcon /></div>
          {!isMobile && <div className={styles["locl-header-dropdown__button-text"]} data-testid="locl-header-dropdown-currency-button-text">{get(selectedCurrency, "label", "")}</div>}
          <div className={styles["locl-header-dropdown__button-icon"]}><FaChevronDown className="locl-hirer-header-dropdown__value-arrow_icon"/></div>
        </div>
      </Dropdown>
      {!isMobile && <InfoTooltip placement="bottom" title={CURRENCY_TOOLTIP_INFO} />}
    </div>
  );

};

export default HeaderCurrencySelector;
